var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-info"},[_c('h2',{staticClass:"mb-4"},[_vm._v(_vm._s(_vm.$t('core.payment.titles.methods')))]),_c('methods')],1)}
var staticRenderFns = []

export { render, staticRenderFns }